import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "form", "open"];

  connect() {}

  toggle() {
    this.formTarget.classList.toggle("hidden");
    if (this.openTarget.value) {
      this.openTarget.value = false;
    } else {
      this.openTarget.value = true;
    }
  }

  clear() {
    this.formTarget.reset();
  }

  submit() {
    this.formTarget.requestSubmit();
  }
}
